document.addEventListener('DOMContentLoaded',()=>{
  const header=document.querySelector('[data-header]');
  const onScroll=()=>header&&header.classList.toggle('scrolled',window.scrollY>40);
  onScroll();window.addEventListener('scroll',onScroll,{passive:true});

  const slides=[...document.querySelectorAll('[data-hero-slide]')];
  if(slides.length){
    const key='1879-hero-index';
    let index=Number(sessionStorage.getItem(key));
    if(!Number.isInteger(index)||index<0||index>=slides.length){index=Math.floor(Math.random()*slides.length);sessionStorage.setItem(key,String(index));}
    slides[index].classList.add('is-active');
  }

  const menuButton=document.querySelector('[data-menu-button]');
  const drawer=document.querySelector('[data-mobile-drawer]');
  if(menuButton&&drawer){menuButton.addEventListener('click',()=>{const open=drawer.classList.toggle('is-open');menuButton.setAttribute('aria-expanded',String(open));document.body.classList.toggle('menu-open',open);});}

  const io=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting)entry.target.classList.add('is-visible')}),{threshold:.12});
  document.querySelectorAll('.reveal,.product-card,.cat-card').forEach(el=>io.observe(el));
});
